import React from "react";
import { useQuickSightQuick  } from "@/hooks/useQuickReports";

const QuickSightAwsQuickDashboard = () => {
  const { embedUrl } = useQuickSightQuick ();

  return (
    <div className="quicksight-container">
      <iframe
        title="QuickSight Dashboard"
        width="100%"
        height="800px"
        src={embedUrl}
        frameBorder="0"
        allowFullScreen
        className="border rounded-lg"
      />
    </div>
  );
};

export default QuickSightAwsQuickDashboard;
